import {
  React,
  useState,
  useEffect,
  useRef,
  useClientInfo,
  axiosInstance,
  SnackbarAlert,
  Box,
  Button,
  Typography,
  Paper,
  TextField,
 } from "../../utils/commonImports";
import { Grid } from "@mui/material";

const initialForm = {
  client_id: "",
  bunk_name: "",
  bunk_address: "",
  bunk_phone: "",
  bunk_contact_person: "",
  bunk_contact_person_mobile: "",
  bunk_email: "",
  bunk_fuel_surcharge: "",
  fuel_petrol_rate: "",
  fuel_desiel_rate: "",
  fuel_lpg_rate: "",
  fuel_charging_rate: "",
};

export default function BunkFormAdd({ editData, onCancel, onSuccess, open = true }) {
  const { clientId } = useClientInfo();

  const [form, setForm] = useState(initialForm);
  const formRef = useRef(null);

  useEffect(() => {
    if (editData) {
      setForm({ ...initialForm, ...editData, client_id: clientId || editData.client_id });
    } else {
      setForm({ ...initialForm, client_id: clientId || "" });
    }
  }, [editData, clientId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSave = async () => {
    try {
      let bunkId = editData?.bunkid;
      const payload = { ...form, client_id: clientId };

      if (bunkId) {
        await axiosInstance.put(`/api/bunks/${bunkId}`, payload);
        SnackbarAlert("Bunk updated successfully", "success");
      } else {
        await axiosInstance.post(`/api/bunks`, payload);
        SnackbarAlert("Bunk created successfully", "success");
      }

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Failed to save bunk:", error);
      SnackbarAlert("Failed to save bunk.", "error");
    }
  };

  if (!open) return null;

   return (
    <Paper
      elevation={3}
      sx={{
        position: "fixed",
        top: 56,
        left: 200,
        right: 0,
        bottom: 0,
        overflowY: "auto",
        p: 4,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h6" mb={3} color="primary">
        {editData ? "Edit Bunk" : "New Bunk"}
      </Typography>

      <Grid container spacing={3} direction="column">
        {/* All normal fields full width row */}
        <Grid item xs={12}>
          <TextField
            label="Bunk Name"
            name="bunk_name"
            value={form.bunk_name}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Bunk Address"
            name="bunk_address"
            value={form.bunk_address}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
            size="small"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Bunk Phone"
            name="bunk_phone"
            value={form.bunk_phone}
            onChange={handleChange}
            fullWidth
            size="small"
            inputProps={{ maxLength: 12 }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Contact Person"
            name="bunk_contact_person"
            value={form.bunk_contact_person}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Contact Person Mobile"
            name="bunk_contact_person_mobile"
            value={form.bunk_contact_person_mobile}
            onChange={handleChange}
            fullWidth
            size="small"
            inputProps={{ maxLength: 12 }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Email"
            name="bunk_email"
            value={form.bunk_email}
            onChange={handleChange}
            fullWidth
            size="small"
            type="email"
          />
        </Grid>

        {/* One row with multiple fields in one line */}
        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Petrol Rate"
              name="fuel_petrol_rate"
              value={form.fuel_petrol_rate}
              onChange={handleChange}
              size="small"
              type="number"
              inputProps={{ step: "0.01" }}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Diesel Rate"
              name="fuel_desiel_rate"
              value={form.fuel_desiel_rate}
              onChange={handleChange}
              size="small"
              type="number"
              inputProps={{ step: "0.01" }}
              sx={{ flex: 1 }}
            />
            <TextField
              label="LPG Rate"
              name="fuel_lpg_rate"
              value={form.fuel_lpg_rate}
              onChange={handleChange}
              size="small"
              type="number"
              inputProps={{ step: "0.01" }}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Fuel Charging Rate"
              name="fuel_charging_rate"
              value={form.fuel_charging_rate}
              onChange={handleChange}
              size="small"
              type="number"
              inputProps={{ step: "0.01" }}
              sx={{ flex: 1 }}
            />
          </Box>
        </Grid>

        {/* Buttons row */}
        <Grid item xs={12} sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
          >
            {editData ? "Update" : "Save"}
          </Button>
          <Button
            onClick={onCancel}
            variant="outlined"
            color="secondary"
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );

}
